<script>
import { mapActions } from 'vuex'

export default {
  name: 'ShowNotification',
  props: {
    notification: {
      type: Object
    }
  },
  emits: [
    'update:notification',
    'notificationRead'
  ],
  computed: {
    showModal: {
      get () {
        return this.notification !== null
      },
      set (v) {
        if (!v) {
          this.$emit('update:notification', null)
        }
      }
    }
  },
  watch: {
    notification: function (v) {
      if (v && v.id && v.read_at === null) {
        this.deleteNotification(v.id).then(() => {
          this.$emit('notificationRead', v.id)
        })
      }
    }
  },
  methods: {
    ...mapActions('notificationStore', ['deleteNotification'])
  }
}
</script>

<template>
<v-dialog
  width="600px" v-model="showModal"
>
  <v-card>
    <v-card-text class="pt-6" v-if="notification">
      <v-chip size="small">{{ notification.created_at | moment('DD.MM.YYYY HH:mm') }}</v-chip>
      <div class="text-h6 my-2">{{notification.data.title}}</div>
      <div class="lines-text">{{notification.data.message}}</div>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<style scoped lang="sass">

</style>
